<template>
  <a-modal
    :title="name"
    :width="1200"
    :footer="null"
    @cancel="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <!--表单-->
      <a-table :columns="columns"
               :data-source="data"
               :pagination="false"
               bordered
      >
        <!--<a slot="name" slot-scope="text">{{ text }}</a>-->
        <template slot="avatar" slot-scope="text, record">
          <img :src="text" alt="" style="width: 50px;height: 50px">
        </template>
      </a-table>
      <!--用户数据统计-->
      <div style="background-color: #fff; padding: 20px;">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-card  :bordered="true" style="background-color: #fafafa">
              <div style="text-align: center">提交订单笔数<span style="font-size: 20px;font-weight: bold;margin: 0 10px">{{orderDetail.submitOrderNum}}</span>笔</div>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card  :bordered="true" style="background-color: #fafafa">
            <div style="text-align: center">成交笔数<span style="font-size: 20px;font-weight: bold;margin: 0 10px">{{orderDetail.orderNum}}</span>笔</div>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card  :bordered="true" style="background-color: #fafafa">
            <div style="text-align: center">消费金额<span style="font-size: 20px;font-weight: bold;margin: 0 10px">{{orderDetail.orderMoney}}</span>元</div>
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card  :bordered="true" style="background-color: #fafafa">
            <div style="text-align: center">加入购物车<span style="font-size: 20px;font-weight: bold;margin: 0 10px">{{orderDetail.carNum}}</span>件</div>
            </a-card>
          </a-col>
        </a-row>
      </div>
      <!--用户购物详情细节-->
      <div>
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="订单">
            <s-table
              ref="table"
              size="default"
              :rowKey="(record) => record.id"
              :columns="orderColumns"
              :data="orderLoadData"
            >
              <template slot="avatar" slot-scope="text, record">
                <img :src="text" alt="" style="width: 50px;height: 50px">
              </template>
              <template slot="action" slot-scope="text, record">
                <a @click="$refs.userAdd.edit(record)">编辑</a>
              </template>
            </s-table>
          </a-tab-pane>
          <a-tab-pane key="2" tab="地址管理" force-render>
            <s-table
              ref="addressTable"
              size="default"
              :rowKey="(record) => record.id"
              :columns="addressColumns"
              :data="addressLoadData"
            >
              <template slot="avatar" slot-scope="text, record">
                <img :src="text" alt="" style="width: 50px;height: 50px">
              </template>
              <template slot="addressAction" slot-scope="text, record">
                <a @click="$refs.userLogisticsAddressAdd.edit(record)">编辑</a>
              </template>
            </s-table>
          </a-tab-pane>
          <a-tab-pane key="3" tab="购物车">
            <s-table
              ref="shopCarTable"
              size="default"
              :rowKey="(record) => record.id"
              :columns="shopCarColumns"
              :data="shopCarLoadData"
            >
              <template slot="imageUrl" slot-scope="text, record">
                <img :src="text" alt="" style="width: 50px;height: 50px">
              </template>
              <template slot="shopCarAction" slot-scope="text, record">
                <a @click="$refs.userLogisticsAddressAdd.edit(record)">编辑</a>
              </template>
            </s-table>
          </a-tab-pane>
          <!--<a-tab-pane key="4" tab="足迹">-->
          <!--</a-tab-pane>-->
        </a-tabs>
<!--        <user-logistics-address-add ref="userLogisticsAddressAdd" @ok="handleOk" />-->
      </div>
    </a-spin>
  </a-modal>
</template>

<script>

  import fieldRule from '@/utils/field-validate-rules'
  import { postAxios, getAxios } from '@/api/request'
  import { STable, Ellipsis } from '@/components'
  import userLogisticsAddressAdd from '../../userLogisticsAddress/modules/userLogisticsAddressAdd'

  const formList = {
    userNo: '',
    avatar: '',
    nickName: '',
    sex: ''
  }
  export default {
    name: 'userAdd',
    components: {
      STable,
      Ellipsis,
      userLogisticsAddressAdd
    },
    data () {
      return {
        // 验证组件
       fieldRule,
        name: '',
        mode: '',
        formData: { ...formList },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        visible: false,
        confirmLoading: false,
        columns: [
          {
            title: '用户编号',
            dataIndex: 'userNo',
            ellipsis: true
          },
          {
            title: '头像',
            dataIndex: 'avatar',
            ellipsis: true,
            scopedSlots: { customRender: 'avatar' }
          },
          {
            title: '昵称',
            ellipsis: true,
            dataIndex: 'nickName'
          },
          {
            title: '性别',
            ellipsis: true,
            dataIndex: 'sex',
            customRender: (text, row, index) => {
              if (text === 1) {
                return '男'
              } else if (text === 2) {
                return '女'
              } else {
                return '其他'
              }
            }
          },
          {
            title: '销售员编号',
            ellipsis: true,
            dataIndex: 'sellerNo'
          }
        ],
        data: [],
        orderDetail: {
          submitOrderNum: '0',
          orderMoney: '0',
          orderNum: '0',
          carNum: '0'
        },
        userNo: '',
    //    form: this.$form.createForm(this), // 注册后，才能通过表单拉取数据
        // 用户订单表
        orderColumns: [
          {
            title: '订单编号',
            dataIndex: 'orderNo',
            ellipsis: true
          },
          {
            title: '订单日期',
            dataIndex: 'orderDate',
            ellipsis: true,
            customRender: (text, row, index) => {
              return new Date(parseInt(text)).toLocaleDateString().replace(/\//g, "-")+ " " + new Date(parseInt(text)).toTimeString().substr(0, 8)
            }
          },
          {
            title: '总金额',
            ellipsis: true,
            dataIndex: 'totalAmount'
          },
          {
            title: '实际金额',
            ellipsis: true,
            dataIndex: 'actualAmount'
          },
          {
            title: '退款金额',
            ellipsis: true,
            dataIndex: 'refundAmount'
          },
          {
            title: '状态',
            ellipsis: true,
            dataIndex: 'status',
            customRender: (text, row, index) => {
              if (text === 'unpaid') {
                return '未付款'
              } else if (text === 'paid') {
                return '已付款'
              } else if (text === 'delivered') {
                return '已发货'
              } else if (text === 'finish') {
                return '完成'
              } else if (text === 'closed') {
                return '超时关闭'
              } else if (text === 'refunding') {
                return '退款申请'
              } else if (text === 'refunded') {
                return '已退款'
              }
            }
          },
          {
            title: '备注',
            ellipsis: true,
            dataIndex: 'remark'
          }
        ],
        // 加载数据方法 必须为 Promise 对象 county
        orderLoadData: parameter => {
          const  params = {}
          params.pageNo = parameter.pageNum
          params.pageSize = parameter.pageSize
          params.userNo = this.userNo
          return postAxios('orderList', params)
            .then(res => {
              const data = {}
              console.log(res)
              data.data = res.rows
              data.pageNum = parameter.pageNum
              data.totalCount = res.total
              return data
            })
        },
        // 用户地址管理表
        addressColumns: [
          {
            title: '收件人',
            dataIndex: 'receiver',
            ellipsis: true
          },
          {
            title: '电话',
            dataIndex: 'phone',
            ellipsis: true
          },
          {
            title: '收货地址',
            dataIndex: 'fullAddress'
          },
          {
            title: '默认',
            ellipsis: true,
            dataIndex: 'defaulted',
            customRender: (text, row, index) => {
              if (text) {
                return '是'
              } else {
                return '否'
              }
            }
          },
          // {
          //   title: '操作',
          //   dataIndex: 'addressAction',
          //   align: 'center',
          //   ellipsis: true,
          //   scopedSlots: { customRender: 'addressAction' }
          // }
        ],
        // 加载数据方法 必须为 Promise 对象 county
        addressLoadData: parameter => {
          const  params = {}
          params.pageNo = parameter.pageNum
          params.pageSize = parameter.pageSize
          params.userNo = this.userNo
          return postAxios('userLogisticsAddressList', params)
            .then(res => {
              const data = {}
              console.log(res)
              data.data = res.rows
              data.pageNum = parameter.pageNum
              data.totalCount = res.total
              return data
            })
        },
        // 购物车
        shopCarColumns: [
          {
            title: '商品编号',
            dataIndex: 'goodsNo',
            ellipsis: true
          },
          {
            title: '商品名称',
            dataIndex: 'goodsName',
            ellipsis: true
          },
          {
            title: '商品图片',
            dataIndex: 'imageUrl',
            ellipsis: true,
            scopedSlots: { customRender: 'imageUrl' }
          },
          {
            title: '商品价格',
            dataIndex: 'price',
            ellipsis: true
          },
          {
            title: '数量',
            dataIndex: 'qty',
            ellipsis: true
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            customRender: (text, row, index) => {
              return new Date(parseInt(text)).toLocaleDateString().replace(/\//g, "-")+ " " + new Date(parseInt(text)).toTimeString().substr(0, 8)
            }
          },
          // {
          //   title: '操作',
          //   dataIndex: 'addressAction',
          //   align: 'center',
          //   ellipsis: true,
          //   scopedSlots: { customRender: 'shopCarAction' }
          // }
        ],
        // 加载数据方法 必须为 Promise 对象 county
        shopCarLoadData: parameter => {
          const  params = {}
          params.pageNo = parameter.pageNum
          params.pageSize = parameter.pageSize
          params.userNo = this.userNo
          return postAxios('shoppingCartList', params)
            .then(res => {
              const data = {}
              console.log(res)
              data.data = res.rows
              data.pageNum = parameter.pageNum
              data.totalCount = res.total
              return data
            })
        }

      }
    },
    methods: {
      edit (record) {
        this.name = '用户详情'
        this.visible = true
        this.data = []
        if (record) {
          this.userNo = record.userNo
          this.formData = record
          this.data.push(this.formData)
          this.getOrder(record.userNo)
          setTimeout(() => {
            this.$refs.table.refresh()
            this.$refs.addressTable.refresh()
            this.$refs.shopCarTable.refresh()
          }, 1)
        }
      },
      // 获取用户订单详情
      getOrder(userNo) {
        const parms = {}
        parms.userNo = userNo
        return postAxios('userOrderCount', parms).then(res => {
          this.orderDetail = res
          })
      },
      handleSubmit () {
        this.confirmLoading = true
      },
      handleCancel () {
        this.visible = false
        this.confirmLoading = false
        // this.form.resetFields() // 清空表单
        this.formData = { ...formList }
      },
      callback(key) {
        console.log(key)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/userManage/modules/userAdd.vue